// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"1320": "c0ecc193cc05","494": "4077578422d4","5336": "5083bc5218c4",}[chunkId] + ".css"
}